import React from "react";
import { ReactComponent as IconComment } from '../assets/icons/custom/Comments.svg'
import { ReactComponent as IconCircle } from '../assets/icons/shape/Circle.svg'
import { ReactComponent as IconLine } from '../assets/icons/shape/Line.svg'
import { ReactComponent as IconRectangle } from '../assets/icons/shape/Rectangle.svg'
import { ReactComponent as IconStar } from '../assets/icons/shape/Star.svg'
import { ReactComponent as IconTriangle } from '../assets/icons/shape/Triangle.svg'
import { ReactComponent as IconLineArrow } from '../assets/icons/custom/Arrow.svg'
import { ReactComponent as IconTwoSidedLineArrow } from '../assets/icons/custom/arrowleftright.svg'
import { ReactComponent as IconAreaSelection } from '../assets/icons/shape/AreaSelection.svg'
import { ReactComponent as IconTwoPointSelection } from '../assets/icons/shape/TwoPointSelection.svg'

const getSelectedIcon = (shape) => {
    switch (shape) {
        case "rect":
            return <IconRectangle />;
        case "triangle":
            return <IconTriangle />;
        case "circle":
            return <IconCircle />;
        case "star":
            return <IconStar />;
        case "line":
            return <IconLine />;
        default:
            return <IconRectangle />;
    }
};
const getSelectedLineIcon = (shape) => {
    switch (shape) {
        case "lineArrow":
            return <IconLineArrow />;
        case "straightLine":
            return <IconLine />;
        case "lineArrowLeftRight":
            return <IconTwoSidedLineArrow />;
        case "endCapsLine":
            return <IconTwoPointSelection />;
        case "rectangle3sided":
            return <IconAreaSelection />;
        default:
            return <IconLineArrow />;
    }
};

const getCommentSelectedIcon = (value) => {
    // switch (value) {
    //     case 'single point':
    //         return <IconSingleComment />
    //     case 'double point':
    //         return <IconDoubleComment />
    //     default:
    return <IconComment />;
    // }
};

export const Icons = {
    getSelectedIcon,
    getCommentSelectedIcon,
    getSelectedLineIcon
};
